import Vue from "vue";

export const toValidationErrorMessageList = (object) => {
  if (!object) return "";
  return "<ol><li>" + Object.values(object).join("</li><li>") + "</li></ol>";
};

export const _errorMessage = (message, data) => {
  return data !== null && typeof data === "object"
    ? toValidationErrorMessageList(data)
    : message;
};

export const _errorAlert = (message, data = null) => {
  let errorMsg = _errorMessage(message, data);
  Vue.prototype.$swal("Error", errorMsg, "error");
};

export const _errorHandler = (error, callback = null) => {
  if (error?.response) {
    let response = error?.response?.data;

    // If response is ArrayBuffer, convert it to string and parse it to JSON
    if (response instanceof ArrayBuffer) {
      let string = arrayBufferToString(response);
      response = JSON.parse(string);
    }

    const { status, message, data } = response;
    let errorMsg = _errorMessage(message, data);
    Vue.prototype.$swal("Error", errorMsg, "error").then(() => {
      if (typeof callback === "function") {
        callback();
      }
    });
  } else {
    console.error(error);
  }
};

export const forceFileDownload = (response, filename) => {
  let responseData = response?.data;
  if (responseData instanceof ArrayBuffer) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      link.remove();
    }, 1000);
  }
};

export const download = (filename, text) => {
  let element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export const arrayBufferToString = (arrayBuffer) => {
  // return String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
  // Create a TextDecoder instance with the desired encoding (e.g., 'utf-8')
  const textDecoder = new TextDecoder("utf-8");

  // Convert the ArrayBuffer to a string
  const decodedString = textDecoder.decode(arrayBuffer);

  return decodedString;
};
